var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterLineBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 1 224",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1412 0H28v224h-1440z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fcfcff",
    fillRule: "nonzero",
    d: "m-1104 .5-308 87V224H28V87.5l-898.5-8-233.5-79Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#c1ced9",
    d: "m-1412 87 308-86.5 233.5 79 898.5 8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLineBg);
export default __webpack_public_path__ + "static/media/footer-line-bg.79172c3e0766dfeb9c2ec9c0a2c84340.svg";
export { ForwardRef as ReactComponent };